import request from 'superagent'
import R from 'ramda'

import {
  AUTH_API_URL,
  METHODS
} from '_constants'

import {
  notNilOrEmpty
} from '_utils'

export const makeRequest = R.curry((method, urlPath, data) => {
  const url = `${AUTH_API_URL}${urlPath}`
  const xhr = request[method](url)
    .withCredentials()
    .set('Content-Type', 'application/json')
    .accept('json')
  // if (headers) {
  //  xhr.set(headers)
  // }
  if (notNilOrEmpty(data) && (method === METHODS.POST || method === METHODS.PUT || method === METHODS.PATCH)) {
    xhr.send(data)
  }
  if (notNilOrEmpty(data) && (method === METHODS.GET)) {
    xhr.query(data)
  }
  return xhr
    .then(res => {
      const errMsg = R.path(['body', 'error'], res)
      if (notNilOrEmpty(errMsg)) {
        return Promise.reject(new Error(errMsg))
      }
      return Promise.resolve(R.propOr({}, 'body', res || {}))
    })
    .catch(err => {
      if (R.path(['response', 'body', 'error'], err)) {
        const errMsg = R.path(['response', 'body', 'error'], err)
        return Promise.reject(new Error(errMsg))
      }
      return Promise.reject(err)
    })
})
export const post = makeRequest(METHODS.POST)
export const patch = makeRequest(METHODS.PATCH)
export const get = makeRequest(METHODS.GET)



// WEBPACK FOOTER //
// ./webAdmin/utils/xhr.js